var React = require('react');

function StepCircle0348px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"fillRule":"evenodd","d":"M24 46C11.85 46 2 36.15 2 24S11.85 2 24 2s22 9.85 22 22-9.85 22-22 22m0-46C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m-5.577 31.142c.832.546 2.496 1.144 4.394 1.144 4.03 0 6.162-2.366 6.162-5.07 0-2.366-1.69-3.926-3.77-4.316v-.052c2.054-.754 3.12-2.236 3.12-4.004 0-2.054-1.508-4.03-4.836-4.03-1.82 0-3.536.65-4.446 1.3l.624 1.664c.728-.52 2.028-1.118 3.38-1.118 2.106 0 2.964 1.196 2.964 2.548 0 2.002-2.106 2.86-3.77 2.86h-1.274v1.716h1.274c2.21 0 4.342 1.014 4.368 3.38.026 1.43-.91 3.276-3.822 3.276-1.612 0-3.094-.65-3.744-1.04l-.624 1.742z"}));
}

StepCircle0348px.displayName = "StepCircle0348px";

StepCircle0348px.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = StepCircle0348px;

StepCircle0348px.default = StepCircle0348px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/48px/step-circle-03-48px.svg
// module id = 1154
// module chunks = 0